import {
  InvoiceDateValidationResult,
  InvoiceIdsValidationResult,
} from "../../../pages/admin-dashboard/admin-invoice/admin-invoice.model";

const NUMERIC_ONLY = /^\d+$/;

export function validateInvoiceIds(invoiceId: string, orderId: string, isArabic: boolean): InvoiceIdsValidationResult {
  const invoiceIdError =
    invoiceId && !NUMERIC_ONLY.test(invoiceId)
      ? isArabic
        ? 'يجب أن يحتوي رقم الفاتورة على أرقام فقط.'
        : 'Invoice ID must contain numbers only.'
      : null;

  const orderIdError =
    orderId && !NUMERIC_ONLY.test(orderId)
      ? isArabic
        ? 'يجب أن يحتوي رقم الطلب على أرقام فقط.'
        : 'Order ID must contain numbers only.'
      : null;

  return {
    invoiceIdError,
    orderIdError,
    isValid: !invoiceIdError && !orderIdError,
  };
}


export function validateInvoiceDates(
  from: string | null,
  to: string | null,
  isArabic: boolean,
): InvoiceDateValidationResult {
  let fromDateError: string | null = null;
  let toDateError: string | null = null;

  const today = new Date();
  if (from) {
    const fromDate = new Date(from);

    if (fromDate > today) {
      fromDateError = isArabic
        ? 'لا يمكن اختيار تاريخ مستقبلي.'
        : 'Future dates cannot be selected.';
    }
  }

  if (to) {
    const toDate = new Date(to);

    if (toDate > today) {
      toDateError = isArabic
        ? 'لا يمكن اختيار تاريخ مستقبلي.'
        : 'Future dates cannot be selected.';
    }
  }

  if (from && to) {
    const fromDate = new Date(from);
    const toDate = new Date(to);

    if (fromDate > toDate) {
      const message = isArabic
        ? 'تاريخ البداية لا يمكن أن يكون بعد تاريخ النهاية.'
        : 'From date cannot be after To date.';

      fromDateError = message;
      toDateError = message;
    }
  }

  return {
    fromDateError,
    toDateError,
    isValid: !fromDateError && !toDateError,
  };
}